import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { Error401VM } from './Error401VM';
import { SecondaryButton } from 'nrcs-design-system';
import { mdiHome } from '@mdi/js';
import './error401.scss';

const Error401Component = (props) => {
  const vm = useRef(new Error401VM(props)).current;

  return (
    <div className="401-page" role="main">
      <div className="error-container" role="alert">
        <div className="error-title mb-5">
          <p id="error-subtitle">Page could not be reached</p>
          <h1>Oh no! Error 401</h1>
          <SecondaryButton iconLeft={mdiHome} className="login-button pb-2 pt-2 pl-3 pr-3" onClick={vm.onSubmit}>
            Back to Login
          </SecondaryButton>
        </div>
        <hr role="presentation" />
        <div className="error-description mt-5">
          <p className="mb-1">You do not have authorization to access this page.</p>
          <p>Please reach out to your system administrator.</p>
        </div>
      </div>
    </div>
  );
};

export const Error401 = observer(Error401Component);
